import React from 'react';
import {Button, OverlayTrigger, Tooltip} from '@goproblems/ui';
import {Image} from '@goproblems/ui';

import {Mode} from '@types';
import {OverlayInjectedProps} from '@goproblems/ui';
import {isMobile} from 'react-device-detect';
import {isEmpty} from 'lodash';

const DELAY_SHOW = 200;
const DELAY_HIDE = 150;

export const BoardToolbarButton = ({
    iconPath,
    icon,
    tooltip = '',
    tooltipPlacement = 'right',
    className = '',
    disabled = false,
    active = false,
    size = 34,
    width,
    height,
    iconRatio = 0.6,
    alt = '',
    onClick,
}: {
    icon?: React.ReactNode;
    iconPath?: string;
    tooltip?: string;
    tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left';
    active?: boolean;
    disabled?: boolean;
    mode?: Mode;
    className?: string;
    size?: number;
    width?: number;
    height?: number;
    iconRatio?: number;
    alt?: string;
    onClick?: () => void;
}) => {
    const renderTooltip = (props: OverlayInjectedProps): React.ReactNode => (
        <Tooltip {...props}>{tooltip}</Tooltip>
    );

    const ToolButton = (
        <Button
            type="button"
            disabled={disabled}
            active={active}
            variant="outline-secondary"
            style={{width: width || size, height: height || size}}
            className={`p-3 md:my-0 md:p-0 !rounded-[2px] !border-[var(--ui-border-strong)] text-neutral-600 ${active ? '!bg-neutral-500' : 'bg-white'} hover:!bg-neutral-500 ${className} relative `}
            onClick={onClick}>
            {icon ? (
                <div
                    style={{width: `${iconRatio * 100}%`}}
                    className="flex absolute justify-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer">
                    {icon}
                </div>
            ) : (
                <Image
                    className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                    src={iconPath}
                    alt={alt}
                    width={`${iconRatio * 100}%`}
                    height={size}
                />
            )}
        </Button>
    );

    return isMobile || isEmpty(tooltip) ? (
        ToolButton
    ) : (
        <OverlayTrigger
            placement={tooltipPlacement}
            overlay={renderTooltip}
            delay={{show: DELAY_SHOW, hide: DELAY_HIDE}}>
            {/* TODO: Reverse color when button state is active */}
            {ToolButton}
        </OverlayTrigger>
    );
};

export default BoardToolbarButton;
